import u from "react";
import { jsx as f } from "react/jsx-runtime";
const T = (e) => `${e}.errormessage`, J = (e) => `u11f.${e}`, Q = {
  position: "absolute",
  width: "1px",
  height: "1px",
  padding: 0,
  margin: "-1px",
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  borderWidth: 0
}, F = (e) => e !== null && typeof e == "object" && !Array.isArray(e) && !(e instanceof Date), z = (e) => F(e) ? e : {};
let D = 0;
const X = (e = 0) => {
  D = D + 1;
  const t = {
    scope: D,
    count: e
  };
  return () => (t.count = t.count + 1, `${D.toString(16)}.${t.count.toString(16)}`);
}, b = {
  defaultMerge: Symbol("deepmerge-ts: default merge"),
  skip: Symbol("deepmerge-ts: skip")
};
b.defaultMerge;
function ce(e, t) {
  return t;
}
function N(e) {
  return typeof e != "object" || e === null ? 0 : Array.isArray(e) ? 2 : de(e) ? 1 : e instanceof Set ? 3 : e instanceof Map ? 4 : 5;
}
function ae(e) {
  const t = /* @__PURE__ */ new Set();
  for (const o of e)
    for (const r of [
      ...Object.keys(o),
      ...Object.getOwnPropertySymbols(o)
    ])
      t.add(r);
  return t;
}
function le(e, t) {
  return typeof e == "object" && Object.prototype.propertyIsEnumerable.call(e, t);
}
function Y(e) {
  return {
    // eslint-disable-next-line functional/functional-parameters
    *[Symbol.iterator]() {
      for (const t of e)
        for (const o of t)
          yield o;
    }
  };
}
const H = /* @__PURE__ */ new Set([
  "[object Object]",
  "[object Module]"
]);
function de(e) {
  if (!H.has(Object.prototype.toString.call(e)))
    return !1;
  const { constructor: t } = e;
  if (t === void 0)
    return !0;
  const o = t.prototype;
  return !(o === null || typeof o != "object" || !H.has(Object.prototype.toString.call(o)) || !o.hasOwnProperty("isPrototypeOf"));
}
function fe(e, t, o) {
  const r = {};
  for (const n of ae(e)) {
    const s = [];
    for (const l of e)
      le(l, n) && s.push(l[n]);
    if (s.length === 0)
      continue;
    const c = t.metaDataUpdater(o, {
      key: n,
      parents: e
    }), a = ee(s, t, c);
    a !== b.skip && (n === "__proto__" ? Object.defineProperty(r, n, {
      value: a,
      configurable: !0,
      enumerable: !0,
      writable: !0
    }) : r[n] = a);
  }
  return r;
}
function me(e) {
  return e.flat();
}
function pe(e) {
  return new Set(Y(e));
}
function ge(e) {
  return new Map(Y(e));
}
function Z(e) {
  return e.at(-1);
}
var G = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  mergeArrays: me,
  mergeMaps: ge,
  mergeOthers: Z,
  mergeRecords: fe,
  mergeSets: pe
});
function Fe(...e) {
  return be({})(...e);
}
function be(e, t) {
  const o = he(e, r);
  function r(...n) {
    return ee(n, o, t);
  }
  return r;
}
function he(e, t) {
  return {
    defaultMergeFunctions: G,
    mergeFunctions: {
      ...G,
      ...Object.fromEntries(Object.entries(e).filter(([o, r]) => Object.hasOwn(G, o)).map(([o, r]) => r === !1 ? [o, Z] : [o, r]))
    },
    metaDataUpdater: e.metaDataUpdater ?? ce,
    deepmerge: t,
    useImplicitDefaultMerging: e.enableImplicitDefaultMerging ?? !1,
    actions: b
  };
}
function ee(e, t, o) {
  if (e.length === 0)
    return;
  if (e.length === 1)
    return R(e, t, o);
  const r = N(e[0]);
  if (r !== 0 && r !== 5) {
    for (let n = 1; n < e.length; n++)
      if (N(e[n]) !== r)
        return R(e, t, o);
  }
  switch (r) {
    case 1:
      return ye(e, t, o);
    case 2:
      return xe(e, t, o);
    case 3:
      return we(e, t, o);
    case 4:
      return Ce(e, t, o);
    default:
      return R(e, t, o);
  }
}
function ye(e, t, o) {
  const r = t.mergeFunctions.mergeRecords(e, t, o);
  return r === b.defaultMerge || t.useImplicitDefaultMerging && r === void 0 && t.mergeFunctions.mergeRecords !== t.defaultMergeFunctions.mergeRecords ? t.defaultMergeFunctions.mergeRecords(e, t, o) : r;
}
function xe(e, t, o) {
  const r = t.mergeFunctions.mergeArrays(e, t, o);
  return r === b.defaultMerge || t.useImplicitDefaultMerging && r === void 0 && t.mergeFunctions.mergeArrays !== t.defaultMergeFunctions.mergeArrays ? t.defaultMergeFunctions.mergeArrays(e) : r;
}
function we(e, t, o) {
  const r = t.mergeFunctions.mergeSets(e, t, o);
  return r === b.defaultMerge || t.useImplicitDefaultMerging && r === void 0 && t.mergeFunctions.mergeSets !== t.defaultMergeFunctions.mergeSets ? t.defaultMergeFunctions.mergeSets(e) : r;
}
function Ce(e, t, o) {
  const r = t.mergeFunctions.mergeMaps(e, t, o);
  return r === b.defaultMerge || t.useImplicitDefaultMerging && r === void 0 && t.mergeFunctions.mergeMaps !== t.defaultMergeFunctions.mergeMaps ? t.defaultMergeFunctions.mergeMaps(e) : r;
}
function R(e, t, o) {
  const r = t.mergeFunctions.mergeOthers(e, t, o);
  return r === b.defaultMerge || t.useImplicitDefaultMerging && r === void 0 && t.mergeFunctions.mergeOthers !== t.defaultMergeFunctions.mergeOthers ? t.defaultMergeFunctions.mergeOthers(e) : r;
}
const ze = ({
  values: e,
  validate: t,
  onSubmit: o,
  valuesDependency: r = !1,
  disabled: n = !1,
  allowSubmitAttempt: s = !1,
  allowErrorSubmit: c = !1,
  translate: a = (l) => l
}) => {
  const l = u.useMemo(() => J(Me()), []), [
    { resetId: h, completed: I, touchedValues: S, values: p, alert: v, submitting: k, attemptedSubmit: _ },
    U
  ] = u.useState(() => W(e)), A = u.useRef(null);
  A.current = h;
  const y = u.useCallback(
    (i) => U(
      (d) => typeof i == "function" ? { ...d, ...i(d) } : { ...d, ...i }
    ),
    []
  ), P = u.useCallback(
    (i = e) => U(() => W(i)),
    [e]
  );
  u.useEffect(() => {
    r && P();
  }, [P, r]);
  const re = (i) => {
    y(({ touchedValues: d }) => ({ touchedValues: Fe(d, i) }));
  }, oe = (i, d = !0) => {
    y(({ values: m }) => ({ values: { ...m, ...i }, completed: !1 }));
  }, K = u.useMemo(() => t ? t(p) : {}, [p, t]), { mappedErrors: ne, isFormValid: $ } = u.useMemo(() => {
    const i = (m, j) => Object.keys(m).reduce((x, g) => {
      const E = j[g], O = m[g];
      return F(O) ? {
        ...x,
        [g]: i(O, z(E))
      } : { ...x, [g]: E };
    }, {}), d = i(p, K);
    return { mappedErrors: d, isFormValid: !Se(d) };
  }, [K, p]), { mappedTouched: se, isFormTouched: ue } = u.useMemo(() => {
    const i = (m, j) => Object.keys(m).reduce((x, g) => {
      const E = m[g], O = j[g];
      return F(E) ? {
        ...x,
        [g]: i(E, z(O))
      } : { ...x, [g]: !!O };
    }, {}), d = i(p, S);
    return { mappedTouched: d, isFormTouched: ve(d) };
  }, [S, p]), V = I || k || n, ie = V || c ? !1 : !$, L = {
    id: l,
    values: p,
    touched: se,
    errors: ne,
    alert: v,
    isSubmitting: k,
    isTouched: ue,
    isValid: $,
    isCompleted: I,
    isFormDisabled: V,
    isAllowingSubmitAttempt: s,
    attemptedSubmit: _,
    isSubmitDisabled: V || c ? !1 : s ? _ ? !$ : !1 : !$,
    // methods
    setAssertive: (i) => y({ alert: i }),
    setValues: oe,
    setTouched: re,
    completed: () => y({ completed: !0 }),
    reset: P,
    translate: a,
    submit: () => {
    }
  };
  return { ...L, submit: async (i) => {
    if (i && i.preventDefault(), y({ attemptedSubmit: !0 }), ie)
      return;
    const d = A.current;
    y({ alert: null, submitting: !0 });
    let m = null;
    try {
      m = await o(L, i);
    } catch (x) {
      console.error(x);
    }
    if (A.current !== d)
      return;
    y({ alert: typeof m == "string" ? m : null, submitting: !1 });
  } };
}, W = (e) => ({
  resetId: Symbol("ResetId"),
  attemptedSubmit: !1,
  submitting: !1,
  alert: null,
  completed: !1,
  touchedValues: {},
  values: e
}), Me = X(), Se = (e) => {
  const t = (o) => Object.keys(o).reduce((r, n) => {
    if (r)
      return !0;
    const s = o[n];
    return typeof s == "string" ? !0 : F(s) ? t(s) : !1;
  }, !1);
  return t(e);
}, ve = (e) => {
  const t = (o) => Object.keys(o).reduce((r, n) => {
    if (r)
      return !0;
    const s = o[n];
    return s === !0 ? !0 : F(s) ? t(s) : !1;
  }, !1);
  return t(e);
}, Ne = ({ forms: e = [] }) => [e], te = (e, t = {}) => ({
  ...t,
  id: e.id,
  disabled: e.disabled || t.disabled,
  value: typeof e.value == "string" ? e.value : void 0,
  onChange: (o) => {
    e.controlled || e.setFieldValue(o.target.value), t.onChange && t.onChange(o);
  },
  "data-error": e.showError && e.error ? "" : void 0,
  "data-touched": e.touched ? "" : void 0,
  "data-has-hidden-error": e.error ? "" : void 0,
  "data-disabled": e.disabled ? "" : void 0,
  "data-field-context": e.name,
  "aria-invalid": e.error === null ? "false" : "true",
  "aria-errormessage": e.error === null ? void 0 : T(e.name),
  "aria-disabled": e.disabled ? "true" : "false"
}), Ee = (e) => ({
  id: e.name,
  disabled: e.disabled,
  value: typeof e.value == "string" ? e.value : "",
  onChange: (t) => {
    e.setFieldValue(t.target.value ? t.target.value : null);
  },
  "aria-invalid": e.error === null ? "false" : "true",
  "aria-errormessage": e.error === null ? void 0 : T(e.name),
  "aria-disabled": e.disabled ? "true" : "false"
}), He = (e) => (t) => {
  const o = Ee(t);
  return e(o);
}, We = (e) => (t) => {
  const o = te(t);
  return e(o);
}, qe = (e) => e, Be = (...e) => {
  const t = e.find((o) => typeof o == "string");
  return typeof t == "string" ? t : null;
}, C = u.createContext(null), w = u.createContext(null), M = u.createContext(null), Je = () => {
  const e = u.useContext(C);
  if (e)
    return e;
  throw new Error("Used FormContext outside <Form />");
}, Qe = () => {
  const e = u.useContext(w);
  if (e)
    return e;
  throw new Error("Used FormFieldContext outside <Form.Field />");
}, Xe = () => {
  const e = u.useContext(M);
  if (!e)
    throw new Error("useFieldGroupContext used outside <Form />");
  return e;
};
function Oe(e) {
  return typeof e == "function";
}
const Ie = u.forwardRef(
  ({ form: e, asChild: t, children: o, validate: r, ...n }, s) => {
    const c = {
      ...n,
      "data-use-a11y-form": "",
      "data-submitting": e.isSubmitting ? "" : void 0,
      "data-disabled": e.isFormDisabled ? "" : void 0,
      "data-submit-disabled": e.isSubmitDisabled ? "" : void 0,
      "data-touched": e.isTouched ? "" : void 0,
      "data-completed": e.isCompleted ? "" : void 0,
      "data-valid": e.isValid ? "" : void 0,
      "data-invalid": e.isValid ? void 0 : "",
      method: "post",
      role: "form",
      noValidate: !r,
      onSubmit: (a) => {
        e.submit(a), n.onSubmit && n.onSubmit(a);
      }
    };
    return /* @__PURE__ */ f(C.Provider, { value: e, children: /* @__PURE__ */ f(
      M.Provider,
      {
        value: {
          names: [],
          values: e.values,
          errors: e.errors,
          touched: e.touched,
          setValues: e.setValues,
          setTouched: e.setTouched
        },
        children: t ? (
          // as child
          u.cloneElement(o, { ...c, ref: s })
        ) : (
          // as intrinsic
          /* @__PURE__ */ f("form", { ...c, children: o, ref: s })
        )
      }
    ) });
  }
), $e = () => {
  const e = u.useContext(C), t = u.useContext(M);
  return { ...e, ...t };
}, je = ({ name: e, children: t, controlled: o = !1, ...r }) => {
  const n = $e(), s = u.useMemo(() => e || J(De()), [e]);
  if (!n || !e) {
    const v = {
      inForm: !1,
      value: void 0,
      error: null,
      errorKey: null,
      touched: !1,
      showError: !1,
      disabled: !1,
      name: s,
      id: s,
      controlled: o,
      ...r,
      setFieldValue: () => {
      },
      onChange: () => {
      }
    };
    return /* @__PURE__ */ f(w.Provider, { value: v, children: t });
  }
  if (!n)
    throw new Error("Missing initial <Form.Group />");
  if (!(e in n.values))
    throw new Error(`<Form.Field/> provided with unknown name: '${e}'`);
  const c = n.values[e], a = n.errors[e], l = !!n.touched[e], h = n && a ? n.translate(a) : null, I = n.names.length > 0 ? `${n.id}.${n.names.join(".")}.${e}` : `${n.id}.${e}`, S = (v) => {
    n.setValues({ [e]: v }), n.setTouched({ [e]: !0 });
  }, p = {
    inForm: !0,
    value: c,
    errorKey: a,
    error: h,
    touched: l,
    showError: n.isAllowingSubmitAttempt ? n.attemptedSubmit : l,
    disabled: n ? n.isFormDisabled : !1,
    id: I,
    name: e,
    controlled: o,
    ...r,
    setFieldValue: S,
    onChange: S
  };
  return /* @__PURE__ */ f(w.Provider, { value: p, children: t });
}, q = ({ name: e, ...t }) => {
  const o = u.useContext(C), r = u.useContext(M);
  if (!o)
    throw new Error("<Form.FieldGroup /> used outside <Form />");
  if (!r)
    throw new Error("Missing initial <Form.Group />");
  const n = [...r.names, e], s = r.values[e], c = r.errors[e], a = r.touched[e];
  if (!F(s))
    throw new Error(`<Form.FieldGroup /> no values for name '${e}', found: ${typeof s}`);
  if (!F(c))
    throw new Error(`<Form.FieldGroup /> no errors for name '${e}', found: ${typeof c}`);
  if (!F(a))
    throw new Error(`<Form.FieldGroup /> no touched for name '${e}', found: ${typeof a}`);
  const l = {
    values: s,
    errors: c,
    touched: a,
    names: n,
    setTouched: (h) => {
      r.setTouched({ [e]: h });
    },
    setValues: (h) => {
      r.setValues({ [e]: { ...s, ...h } });
    }
  };
  return /* @__PURE__ */ f(M.Provider, { value: l, children: t.children });
}, De = X(), Ae = ({ asChild: e, children: t, ...o }) => {
  const r = u.useContext(w), n = {
    ...o,
    htmlFor: r != null && r.id ? r.id : o.htmlFor
  };
  return e ? (
    // as child
    u.cloneElement(t, { ...n })
  ) : (
    // as intrinsic
    /* @__PURE__ */ f("label", { ...n, children: t })
  );
}, Pe = u.forwardRef(
  ({ asChild: e, children: t, auto: o, controlled: r = !1, ...n }, s) => {
    const c = u.useContext(w);
    if (c) {
      const a = o ? o === !0 ? "on" : o : "off", l = {
        ...te({ ...c, controlled: r ? !0 : c.controlled }, n),
        autoComplete: a,
        ref: s
      };
      return e ? (
        // as child
        u.cloneElement(t, { ...l })
      ) : (
        // as intrinsic
        /* @__PURE__ */ f("input", { ...l })
      );
    }
    throw new Error("<Form.Input/> used outside <Form.Field/>. No sibling <Form.Label/> found");
  }
), Ve = ({ asChild: e, children: t, ...o }) => {
  const r = u.useContext(w);
  if (!r || !r.inForm)
    return null;
  if (typeof r.error != "string")
    return;
  const n = r.error && r.showError, s = {
    id: T(r.name),
    style: n ? o.style : { ...Q, ...o.style },
    ...o
  };
  return e ? (
    // as child
    u.cloneElement(t, { ...s, children: r.error })
  ) : (
    // as intrinsic
    /* @__PURE__ */ f("p", { ...s, children: r.error })
  );
}, Ge = u.forwardRef(
  ({ asChild: e, children: t, hideUntouched: o = !1, ...r }, n) => {
    const s = u.useContext(C);
    if (!s)
      return null;
    const c = {
      ...r,
      type: "submit",
      style: o && !s.isTouched ? { ...Q, ...r.style } : r.style,
      disabled: s.isFormDisabled || s.isSubmitDisabled,
      "data-submitting": s.isSubmitting,
      ref: n
    };
    return e ? (
      // as child
      u.cloneElement(t, { ...c })
    ) : (
      // as intrinsic
      /* @__PURE__ */ f("button", { ...c, children: t })
    );
  }
), B = ({ asChild: e, children: t, ...o }) => {
  const r = u.useContext(C), n = {
    role: "alert",
    "aria-live": "assertive",
    ...o
  };
  if (e && t.props.children)
    return u.cloneElement(t, { ...n });
  if (!e && t)
    return Oe(t) ? r != null && r.alert ? /* @__PURE__ */ f("p", { ...n, children: t(r.alert) }) : null : /* @__PURE__ */ f("p", { ...n, children: t });
  if (!r || !r.alert)
    return null;
  const s = r.translate(r.alert);
  return e ? (
    // as child
    u.cloneElement(t, {
      ...n,
      children: s
    })
  ) : (
    // as intrinsic
    /* @__PURE__ */ f("p", { ...n, children: s })
  );
}, Re = (e) => {
  const t = u.useContext(C);
  throw t && e.children(t), new Error("<Form.Context/> used outside <Form/>");
}, Te = (e) => {
  const t = u.useContext(w);
  if (t)
    return e.children(t);
  throw new Error("<Form.FieldContext/> used outside <Form.Field/>");
}, ke = (e) => {
  const t = u.useContext(M);
  if (t)
    return e.children(t);
  throw new Error("<Form.FieldGroupContext/> used outside <Form />");
}, Ye = Object.assign(Ie, {
  Field: je,
  FieldGroup: q,
  Group: q,
  Input: Pe,
  Label: Ae,
  Error: Ve,
  Alert: B,
  Assertive: B,
  Submit: Ge,
  Context: Re,
  FieldContext: Te,
  FieldGroupContext: ke
});
export {
  Ye as Form,
  We as adaptInput,
  He as adaptSelect,
  qe as createFieldAdapter,
  Se as someErrors,
  ve as someTouched,
  Qe as useFieldContext,
  Xe as useFieldGroupContext,
  ze as useForm,
  Je as useFormContext,
  Ne as useForms,
  Be as vx
};
